import * as Sentry from "@sentry/browser";

import {
	CONFIG_ENVIRONMENT,
	CONFIG_SENTRY_DSN,
	CONFIG_SENTRY_DEBUG,
} from "./config";
import { debug } from "./shared/debug";

export function Sentry_attach() {
	if (!CONFIG_SENTRY_DSN) {
		debug("sentry disabled: dsn missing");
		return;
	}

	if (!window) {
		debug("sentry: disabled: non-browser environment");
	}

	if (window.location.hostname === "localhost") {
		debug("sentry: disabled: localhost environment");
		return;
	}

	Sentry.init({
		dsn: CONFIG_SENTRY_DSN,
		debug: CONFIG_SENTRY_DEBUG,
		environment: CONFIG_ENVIRONMENT,
		enableLogs: true,
		integrations: [Sentry.browserTracingIntegration()],
		tracePropagationTargets: [
			/^https:\/\/global\.sdk\.myzeller\.(dev|show|com)\/graphql/,
		],
		maxBreadcrumbs: 30,
		sendDefaultPii: true,
		tracesSampleRate: 0.1 /* 10% */,
		beforeSendLog: beforeSendLog(),
		beforeBreadcrumb: beforeBreadcrumb(),
	});

	function beforeSendLog(): Sentry.BrowserOptions["beforeSendLog"] {
		const exclude = new Set<Sentry.LogSeverityLevel>(["debug"]);
		return (log) => (exclude.has(log.level) ? null : log);
	}
	function beforeBreadcrumb(): Sentry.BrowserOptions["beforeBreadcrumb"] {
		return (breadcrumb) => {
			// Ignore all `console.debug` breadcrumbs.
			const { level, category } = breadcrumb;
			if (level === "debug" && category === "console") {
				return null;
			}
			return breadcrumb;
		};
	}

	debug("sentry: ready");
}
